import React, { useEffect, useMemo, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  BlockTitle,
  Button,
  Col,
  Row,
  RSelect,
} from "../../../components/Component";
import {
  Modal,
  ModalBody,
} from "reactstrap";
import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import Table from "../../../components/react-table/Table";

import {
  Controller,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { NumericFormat, numericFormatter } from "react-number-format";
import { Input } from "reactstrap";
import BillPicture from "../../../components/picture/Picture";
import { useUser } from "../../../context/user";
import { GET } from "../../../helper/api";
import {
  BILL_STATUS,
  BILL_TYPE,
  DEFAULT_DELIVERY_PROVIDER_ID,
  INGREDIENT_CATEGORY_ID,
  LOCATION,
  USER_ROLES,
  CURRENCY_CODE_OPTIONS,
  formatLicensePlate,
} from "../../../utils/Utils";
import UpsertCustomer from "../../customermanager/UpsertCustomer";
import { CommissionComponent } from "./CommissionComponent";
const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));

const LOCATION_OPTIONS = Object.keys(LOCATION).map((c) => ({
  label: LOCATION[c],
  value: c,
}));

const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const CreateBillForm = ({
  id,
  duplicateId,
  billData,
  ingredientPriceHistoryOptions,
  externalContractOptions = [],
  disabledForm = false,
  setLoading = () => { },
}) => {
  const { errors, register, control, setValue } = useFormContext();
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [showCreateCustomer, setShowCreateCustomer] = useState(false);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [deliveryProviderOptions, setDeliveryProviderOptions] = useState([]);
  const [mortgageContractOptions, setMortgageContractOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [approvedBillsByIngredientPriceHistory, setApprovedBillsByIngredientPriceHistory] = useState([]);
  const [showApprovedBillsByIngredientPriceHistory, setShowApprovedBillsByIngredientPriceHistory] = useState(false);

  useEffect(() => {
    const handleDocumentKeyDown = (event) => {
      if (event.key === 'Tab') {
        event.preventDefault();
      }
    };
    if (disabledForm) {
      document.addEventListener('keydown', handleDocumentKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleDocumentKeyDown);
    };
  }, [disabledForm]);


  const {
    state: { user },
  } = useUser();
  const { role } = user || {};

  const type = useWatch({
    control,
    name: "type",
  });

  const finalMerchandiseWeightCol = useWatch({
    control,
    name: "finalMerchandiseWeightCol",
  });

  const finalDeliveryWeightCol = useWatch({
    control,
    name: "finalDeliveryWeightCol",
  });

  const ingredientPriceHistoryId = useWatch({
    control,
    name: "ingredientPriceHistoryId",
  });

  const destinationMerchandiseWeight = useWatch({
    control,
    name: "destinationMerchandiseWeight",
  });

  const departureMerchandiseWeight = useWatch({
    control,
    name: "departureMerchandiseWeight",
  });

  const currency = useWatch({
    control,
    name: "currency",
  });

  const billType = useWatch({
    control,
    name: "type",
  });

  const status = useWatch({
    control,
    name: "status",
  });

  const location = useWatch({
    control,
    name: "location",
  });

  const customerId = useWatch({
    control,
    name: "customerId",
  })


  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });

    GET("customer", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setCustomerOptions(
          data.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
        setDeliveryProviderOptions(
          data.filter(c => c.isDeliveryProvider).map(c => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        )
      } else {
        setCustomerOptions([]);
        setDeliveryProviderOptions([]);
      }
    });
  }, []);

  useEffect(() => {
    setApprovedBillsByIngredientPriceHistory([])
    if (showApprovedBillsByIngredientPriceHistory) {
      GET(`/bill/get-approved-bill-by-ingredient-history/${ingredientPriceHistoryId}`, {}, true).then((resp) => {
        setApprovedBillsByIngredientPriceHistory(resp.data || []);
      });
    }
  }, [showApprovedBillsByIngredientPriceHistory])

  const ingredientId = useWatch({
    control,
    name: "ingredientId",
  });

  const externalContractIncludeSellectedOptions = useMemo(() => {
    const temp = [...externalContractOptions];
    if (billData?.billExternalContract && ingredientId === billData.billExternalContract.ingredientId && !temp.map(e => e.value).includes(billData.billExternalContractId)) {
      temp.push({
        label: billData.billExternalContract.name,
        value: billData.billExternalContract.id,
        data: billData.billExternalContract,
      })
    }
    return temp
  }, [externalContractOptions, billData, ingredientId])

  const onCreateCustomerSuccess = (data) => {
    setShowCreateCustomer(false);
    setValue("customerId", data.id);
    setCustomerOptions([
      ...customerOptions,
      {
        label: data.name,
        value: data.id,
        data: data,
      },
    ]);
  };

  useEffect(() => {
    GET("ingredient", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.filter(c => !!INGREDIENT_CATEGORY_ID[c.id]).map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET(
      "/transaction-history/mortgage-contract",
      { status: "INIT" },
      true
    ).then(({ data }) => {
      setMortgageContractOptions((oldData) => {
        const newData = [...oldData];
        const values = oldData.map((e) => e.value);
        data?.forEach((c) => {
          if (!values.includes(c.contractId)) {
            newData.push({
              label: `${c.contractId} - ${c.bankName} - ${numericFormatter(
                `${c.amountUSD || c.amount || 0}`,
                {
                  thousandsGroupStyle: "thousand",
                  thousandSeparator: ",",
                  decimalScale: 2,
                  suffix: c.currency === "VND" ? "đ" : "",
                  prefix: c.currency === "USD" ? "$" : "",
                }
              )}`,
              value: c.contractId,
              data: c,
            });
          }
        });
        return newData;
      });
    });
  }, []);

  const renderCurrentWeightIngredientPrice = useMemo(() => {
    if (!ingredientPriceHistoryId || !ingredientPriceHistoryOptions.length) {
      return <></>;
    }
    let { currentWeight, quotaWeight, currentNumOfTruck } =
      ingredientPriceHistoryOptions[0]?.data || {};
    currentWeight -=
      billData?.status === "APPROVED" ? billData.finalMerchandiseWeight : 0;
    currentWeight +=
      finalMerchandiseWeightCol === "destination"
        ? destinationMerchandiseWeight || 0
        : departureMerchandiseWeight || 0;
    currentNumOfTruck += (billData?.status === "APPROVED" ? 0 : 1);
    return (
      <span className={currentWeight > quotaWeight ? "text-danger" : ""} onDoubleClick={() => setShowApprovedBillsByIngredientPriceHistory(true)}>
        (Tạm tính:{` `}
        <NumericFormat
          value={currentWeight}
          displayType={"text"}
          decimalScale={2}
          thousandSeparator={","}
          thousandsGroupStyle="thousand"
          suffix={` kg`}
        />{` / `}
        <NumericFormat
          value={currentNumOfTruck}
          displayType={"text"}
          decimalScale={2}
          thousandSeparator={","}
          thousandsGroupStyle="thousand"
          suffix={` xe`}
        />
        )
      </span>
    );
  }, [
    ingredientPriceHistoryId,
    ingredientPriceHistoryOptions,
    billData,
    finalMerchandiseWeightCol,
    destinationMerchandiseWeight,
    departureMerchandiseWeight,
  ]);

  return (
    <>
      <form className="position-relative">
        {disabledForm ? <div className="form-overlay"></div> : <></>}
        <UpsertCustomer
          setLoading={setLoading}
          type={type}
          onSuccess={onCreateCustomerSuccess}
          onFormCancel={() => setShowCreateCustomer(false)}
          isOpen={showCreateCustomer}
        />
        <div className="mb-4">
          <Row className="g-2">
            <Col size={12}>
              <BlockTitle tag="h5">Thông tin khách hàng</BlockTitle>
            </Col>
            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  Khách hàng <span className="text-danger">*</span>
                  {!!id && !billData?.customerId
                    ? ` (Tên từ app cân: ${billData?.tempCustomerName || ""})`
                    : ""}
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="customerId"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, name, ref }) => (
                      <RSelect
                        ref={ref}
                        name={name}
                        options={customerOptions.filter(
                          (e) => e?.data?.type === billType
                        )}
                        value={
                          customerOptions.find((c) => c.value === value) || null
                        }
                        onChange={(val) => {
                          onChange(val.value);
                          setValue('billExternalContractId', null)
                        }}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="customerId"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>
            {!id || !billData?.customerId ? (
              <Col md="6" className="d-flex align-items-end">
                {" "}
                <Button
                  color="primary"
                  type="button"
                  onClick={() => {
                    setShowCreateCustomer(true);
                  }}
                >
                  <span>Tạo mới khách hàng</span>
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
        </div>

        <Row className="mt-3 g-2">
          <Col size={12}>
            <BlockTitle tag="h5">Thông tin đơn hàng</BlockTitle>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label" htmlFor="customer">
                Mã đơn hàng <span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <input
                  type="text"
                  className="form-control"
                  name="id"
                  ref={register({
                    required: "Vui lòng nhập thông tin",
                  })}
                  disabled={!!id && !duplicateId}
                />
                <ErrorMessage
                  errors={errors}
                  name="id"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>


          <Col md="6">
            <div className="form-group">
              <label className="form-label" htmlFor="warehouseId">
                Kho <span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="warehouseId"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      isClearable
                      classNamePrefix="form-control"
                      inputRef={ref}
                      name={name}
                      options={warehouseOptions}
                      value={warehouseOptions
                        .find((c) => c.value === value) || null}
                      onChange={(val) => {
                        onChange(val?.value);
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="warehouseId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="form-group">
              <div className="d-flex">
                <label className="form-label" >
                  Xe tải
                </label>
              </div>

              <Row className="form-control-wrap">

                <Col size="12">
                  <Controller
                    control={control}
                    name="truckId"
                    render={({ onChange, value, name, ref }) => (
                      <input
                        value={value}
                        type="text"
                        className="form-control"
                        name={name}
                        ref={ref}
                        onChange={(e) => onChange(formatLicensePlate(e.target.value))}
                      />
                    )}
                  />
                </Col>
              </Row>
            </div>
          </Col>

          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Loại đơn<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="type"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={BILL_TYPE_OPTIONS}
                      value={
                        BILL_TYPE_OPTIONS.find((c) => c.value === value) || null
                      }
                      onChange={({ value }) => {
                        onChange(value);
                        setValue("customerId", "");
                        setValue("finalMerchandiseWeightCol", value === "IN" ? "departure" : "destination");
                        setValue(
                          "finalDeliveryWeightCol", value === "IN" ? "destination" : "departure"
                        );
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="type"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label className="form-label" >
                Nhà vận chuyển thuê
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="deliveryProviderId"
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={deliveryProviderOptions}
                      value={
                        deliveryProviderOptions.find((c) => c.value === value) || null
                      }
                      onChange={(val) => {
                        const value = val?.value || null;
                        onChange(value);
                        setValue(
                          "finalDeliveryWeightCol",
                          (value?.startWiths(DEFAULT_DELIVERY_PROVIDER_ID))
                            ? (type === "IN" ? "destination" : "departure")
                            : (type === "IN" ? "departure" : "destination")
                        );

                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label className="form-label" >
                Phí vận chuyển(đ)<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="deliveryFeeByWeight"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, value, ref }) => (
                    <NumericFormat
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="deliveryFeeByWeight"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>

          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Nguyên liệu<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="ingredientId"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={ingredientOptions}
                      value={
                        ingredientOptions.find((c) => c.value === value) || null
                      }
                      onChange={(val) => {
                        onChange(val.value)
                        if (location === "EXTERNAL") {
                          setValue('billExternalContractId', undefined)
                          setValue("exchangeRate", 0);
                          setValue("unitPriceUSD", 0);
                          if (ingredientId === INGREDIENT_CATEGORY_ID.DTP) {
                            setValue("pack", 1);
                          }
                        }

                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="ingredientId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>

          <Col md="3">
            <div className="form-group">
              <label className="form-label" >
                Chọn đơn xuất
                {renderCurrentWeightIngredientPrice}
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="ingredientPriceHistoryId"
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={ingredientPriceHistoryOptions}
                      value={
                        ingredientPriceHistoryOptions.find(
                          (c) => c.value === value
                        ) || null
                      }
                      onChange={(val) => {
                        onChange(val?.value);
                        setValue(
                          "unitPrice",
                          ingredientPriceHistoryOptions.find(
                            (c) => c.value === val.value
                          ).data.amount
                        );
                        if (val?.data?.commissions) {
                          setValue("commissions", val.data.commissions.filter(e => e.type === 'SALE').map(e => ({
                            customerId: e.customerId,
                            commissionFeePerWeight: e.commissionFeePerWeight,
                            description: e.description,
                          })));
                        }

                      }}
                    />
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="3">
            <div className="form-group">
              <label className="form-label" >
                Tiền tệ
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="currency"
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={CURRENCY_CODE_OPTIONS}
                      value={CURRENCY_CODE_OPTIONS.find((c) => c.value === value)}
                      onChange={(val) => onChange(val.value)}
                    />
                  )}
                />
              </div>
            </div>
          </Col>

          {currency === "USD" ? (
            <>
              <Col md="2">
                <div className="form-group">
                  <label className="form-label" >
                    Đơn giá đô<span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="unitPriceUSD"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, ref }) => (
                        <NumericFormat
                          className="form-control"
                          getInputRef={ref}
                          type="text"
                          value={value}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          prefix={"$"}
                          decimalScale={4}
                          onValueChange={(val) => onChange(val.floatValue)}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="unitPriceUSD"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>

              <Col md="2">
                <div className="form-group">
                  <label className="form-label" >
                    Tỉ giá<span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="exchangeRate"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, ref }) => (
                        <NumericFormat
                          className="form-control"
                          getInputRef={ref}
                          type="text"
                          value={value}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                          onValueChange={(val) => onChange(val.floatValue)}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="exchangeRate"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
            </>
          ) : (
            <></>
          )}

          <Col md={currency === "VND" ? 6 : 2}>
            <div className="form-group">
              <label className="form-label" >
                Đơn giá VNĐ<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="unitPrice"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, value, ref }) => (
                    <NumericFormat
                      disabled={true}
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="unitPrice"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>

          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Xuất khẩu/Trong nước<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="location"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, name, value, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={LOCATION_OPTIONS}
                      value={
                        LOCATION_OPTIONS.find((c) => c.value === value) || null
                      }
                      onChange={(val) => {
                        onChange(val.value);
                        if (val.value === "EXTERNAL") {
                          setValue("currency", "USD");
                          setValue("exchangeRate", 0);
                          setValue("unitPriceUSD", 0);
                          if (ingredientId === INGREDIENT_CATEGORY_ID.DTP) {
                            setValue("pack", 1);
                          }
                        } else {
                          setValue('billExternalContractId', undefined)
                          setValue("currency", "VND");
                          setValue("exchangeRate", null);
                          setValue("unitPriceUSD", null);
                        }
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="location"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="6" className={location === "EXTERNAL" ? '' : 'd-none'}>
            <div className="form-group">
              <label className="form-label" >
                Hợp đồng xuất khẩu
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="billExternalContractId"
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={externalContractIncludeSellectedOptions.filter(({ data }) => customerId === data.customerId)}
                      value={
                        externalContractIncludeSellectedOptions.find(
                          (c) => c.value === value
                        ) || null
                      }
                      onChange={(val) => {
                        onChange(val?.value || "");
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="billExternalContractId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="6" className={location === "EXTERNAL" ? '' : 'd-none'}>
            <div className="form-group">
              <label className="form-label" >
                Phí vận chuyển xuất khẩu(đ){location === "EXTERNAL" && <span className="text-danger">*</span>}
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="deliveryFeeExternal"
                  rules={location === "EXTERNAL" ? { required: "Vui lòng nhập thông tin" } : {}}
                  render={({ onChange, value, ref }) => (
                    <NumericFormat
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="deliveryFeeExternal"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>


          <Col md="3">
            <div className="form-group">
              <label className="form-label" >
                Số túi
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="pack"
                  render={({ onChange, value, name, ref }) => (
                    <NumericFormat
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
              </div>
            </div>
          </Col>

          <Col md="3">
            <div className="form-group">
              <label className="form-label" >
                Số container
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="numOfContainer"
                  rules={{
                    required: "Vui lòng nhập thông tin",
                  }}
                  render={({ onChange, value, name, ref }) => (
                    <NumericFormat
                      disabled
                      className="form-control"
                      getInputRef={ref}
                      type="text"
                      value={value}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      decimalScale={2}
                      onValueChange={(val) => onChange(val.floatValue)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="numOfContainer"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>

          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Thời gian tạo đơn<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <input
                  rows={3}
                  className="form-control"
                  type="datetime-local"
                  name="createdAt"
                  ref={register({ required: "Vui lòng nhập thông tin" })}
                />
                <ErrorMessage
                  errors={errors}
                  name="createdAt"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Khoản vay
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="contractId"
                  render={({ onChange, name, value, ref }) => (
                    <RSelect
                      isClearable
                      ref={ref}
                      name={name}
                      options={mortgageContractOptions}
                      value={
                        mortgageContractOptions.find((c) => c.value === value) ||
                        null
                      }
                      onChange={(val) => {
                        onChange(val?.value);
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="contractId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label" htmlFor="customer">
                Đơn chuyển kho nội bộ
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="isExchangeInternalInventory"
                  render={({ onChange, value, ref }) => (
                    <div className="custom-control custom-switch">
                      <Input
                        id="isExchangeInternalInventory"
                        className="custom-control-input"
                        inputRef={ref}
                        type="checkbox"
                        checked={!!value}
                        onClick={() => {
                          onChange(!value);
                        }}
                      />
                      <label
                        className="custom-control-label"
                        for="isExchangeInternalInventory"
                      ></label>
                    </div>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col size="12">
            <div className="form-group">
              <label className="form-label" >
                Ghi chú
              </label>
              <div className="form-control-wrap">
                <textarea
                  rows={3}
                  className="form-control"
                  style={{ height: "unset" }}
                  name="note"
                  ref={register()}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col size={12}>
            <BlockTitle tag="h5">Hoa hồng đơn</BlockTitle>
          </Col>
          <Col md="12" className="mt-3">
            <CommissionComponent customerOptions={customerOptions} />
          </Col>
        </Row>
        <div className="mt-4">
          <Row className="g-2">
            <Col size={12}>
              <BlockTitle tag="h5">
                <span>
                  <input
                    ref={register()}
                    name="finalMerchandiseWeightCol"
                    className="mr-1"
                    type="radio"
                    id="departure"
                    value="departure"
                    checked={finalMerchandiseWeightCol === "departure"}
                    disabled={
                      ![
                        USER_ROLES.ADMIN,
                        USER_ROLES.BILL_APPROVER,
                        USER_ROLES.ENTRY_STAFF,
                      ].includes(role)
                    }
                    onChange={(e) =>
                      setValue("finalMerchandiseWeightCol", e.target.value)
                    }
                  />
                  <label htmlFor="departure">Khối lượng theo đơn: Cân lúc đi</label>
                </span>
              </BlockTitle>
            </Col>
            <Col size={12}>
              <BlockTitle tag="h5">
                <span>
                  <input
                    ref={register()}
                    name="finalDeliveryWeightCol"
                    className="mr-1"
                    type="radio"
                    id="departure"
                    value="departure"
                    checked={finalDeliveryWeightCol === "departure"}
                    disabled={
                      ![
                        USER_ROLES.ADMIN,
                        USER_ROLES.BILL_APPROVER,
                        USER_ROLES.ENTRY_STAFF,
                      ].includes(role)
                    }
                    onChange={(e) =>
                      setValue("finalDeliveryWeightCol", e.target.value)
                    }
                  />
                  <label htmlFor="departure">Khối lượng theo VC: Cân lúc đi</label>
                </span>
              </BlockTitle>
            </Col>

            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  KL xe không tải(kg)
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="departureTruckWeight"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        disabled={billData?.MerchandiseWeightCol === "departure"}
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        onValueChange={(val) => onChange(val.floatValue)}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="departureTruckWeight"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>

            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  KL hàng(kg)
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="departureMerchandiseWeight"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        onValueChange={(val) => onChange(val.floatValue)}
                        disabled
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="departureMerchandiseWeight"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>

            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  KL xe có tải(kg)
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="departureTotalWeight"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        disabled={billData?.MerchandiseWeightCol === "departure"}
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        onValueChange={(val) => onChange(val.floatValue)}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="departureTotalWeight"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>

            {(billData && billData?.departureTotalWeightAt && (
              <Col md="6">
                <div className="form-group">
                  <label className="form-label" >
                    Ngày cân lúc đi
                  </label>
                  <div className="form-control-wrap">
                    <input
                      className="form-control "
                      value={moment(billData?.departureTotalWeightAt).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )}
                      disabled
                    />
                  </div>
                </div>
              </Col>
            )) || <></>}
          </Row>
        </div>
        <div className="mt-4">
          <Row className="g-2">
            <Col size={12}>
              <BlockTitle tag="h5">
                <span>
                  <input
                    ref={register()}
                    name="finalMerchandiseWeightCol"
                    className="mr-1"
                    type="radio"
                    id="destination"
                    value="destination"
                    checked={finalMerchandiseWeightCol === "destination"}
                    disabled={
                      ![
                        USER_ROLES.ADMIN,
                        USER_ROLES.BILL_APPROVER,
                        USER_ROLES.ENTRY_STAFF,
                      ].includes(role)
                    }
                    onChange={(e) =>
                      setValue("finalMerchandiseWeightCol", e.target.value)
                    }
                  />
                  <label htmlFor="destination">Khối lượng theo đơn: Cân lúc đến</label>
                </span>
              </BlockTitle>
            </Col>
            <Col size={12}>
              <BlockTitle tag="h5">
                <span>
                  <input
                    ref={register()}
                    name="finalDeliveryWeightCol"
                    className="mr-1"
                    type="radio"
                    id="destination"
                    value="destination"
                    checked={finalDeliveryWeightCol === "destination"}
                    disabled={
                      ![
                        USER_ROLES.ADMIN,
                        USER_ROLES.BILL_APPROVER,
                        USER_ROLES.ENTRY_STAFF,
                      ].includes(role)
                    }
                    onChange={(e) =>
                      setValue("finalDeliveryWeightCol", e.target.value)
                    }
                  />
                  <label htmlFor="destination">Khối lượng theo VC: Cân lúc đến</label>
                </span>
              </BlockTitle>
            </Col>
            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  KL xe không tải(kg)
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="destinationTruckWeight"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        disabled={
                          billData?.MerchandiseWeightCol === "destination"
                        }
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        onValueChange={(val) => onChange(val.floatValue)}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="destinationTruckWeight"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  KL hàng(kg)
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="destinationMerchandiseWeight"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        // onValueChange={(val) =>
                        //   onChange(val.floatValue)
                        // }
                        disabled
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="destinationMerchandiseWeight"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>
            <Col md="6">
              <div className="form-group">
                <label className="form-label" >
                  KL xe có tải(kg)
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="destinationTotalWeight"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, ref }) => (
                      <NumericFormat
                        disabled={
                          billData?.MerchandiseWeightCol === "destination"
                        }
                        className="form-control"
                        getInputRef={ref}
                        type="text"
                        value={value}
                        thousandsGroupStyle="thousand"
                        thousandSeparator=","
                        decimalScale={2}
                        onValueChange={(val) => onChange(val.floatValue)}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="destinationTotalWeight"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>

            {(billData && billData?.destinationTotalWeightAt && (
              <Col md="6">
                <div className="form-group">
                  <label className="form-label" >
                    Ngày cân lúc đến
                  </label>
                  <div className="form-control-wrap">
                    <input
                      className="form-control "
                      value={moment(billData?.destinationTotalWeightAt).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )}
                      disabled
                    />
                  </div>
                </div>
              </Col>
            )) || <></>}
          </Row>
          <Row className="mt-4">
            <Col size={12}>
              <BillPicture disabledUpload={status === BILL_STATUS.APPROVED} />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col size="12" md={3}>
              <div className="form-group">
                <label className="form-label" >
                  Trạng thái đơn<span className="text-danger">*</span>
                </label>
                <div className="form-control-wrap">
                  <Controller
                    control={control}
                    name="status"
                    rules={{
                      required: "Vui lòng nhập thông tin",
                    }}
                    render={({ onChange, value, name, ref }) => (
                      <RSelect
                        ref={ref}
                        name={name}
                        options={BILL_STATUS_OPTIONS}
                        value={
                          BILL_STATUS_OPTIONS.find((c) => c.value === value) ||
                          null
                        }
                        onChange={(val) => onChange(val.value)}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="status"
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </form>
      {showApprovedBillsByIngredientPriceHistory && (
        <Modal size="lg" isOpen={showApprovedBillsByIngredientPriceHistory} toggle={() => setShowApprovedBillsByIngredientPriceHistory(false)}>
          <ModalBody>
            <Table
              notShowPagi
              loading={false}
              columns={[
                {
                  Header: "Mã",
                  accessor: "id",
                },
                {
                  Header: "Xe",
                  accessor: (item) => item?.truckId || "",
                },
                {
                  Header: "Đơn giá(đ)",
                  className: 'text-right',
                  accessor: (item) => <NumericFormat
                    value={item.unitPrice}
                    displayType={'text'}
                    decimalScale={2}
                    thousandSeparator={','}
                    thousandsGroupStyle="thousand"
                  />
                },
                {
                  Header: "KL Hàng(kg)",
                  accessor: (item) => item?.finalMerchandiseWeight || "",
                },
                {
                  Header: "Ngày tạo",
                  accessor: (item) => moment(item.createdAt).format("DD/MM/YYYY HH:mm:ss"),
                },
              ]}
              data={approvedBillsByIngredientPriceHistory}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default CreateBillForm;
